import React from 'react';

import Button from '../../../components/Button/Button';

/**
 * Markup button component
 * @param {Object} props
 * @param {boolean} [props.arrow]
 * @param {string} props.label
 * @param {string} props.link
 */
export const MarkupButton = ({ arrow, label, link }) => {
  return (
    <Button arrow={arrow} href={link}>
      {label}
    </Button>
  );
};

export default MarkupButton;
